<script setup lang="ts">
  /**
   * Section step — 03-components/12c-section-header · OSCloud DS 1.1.47
   */
  withDefaults(defineProps<{ lead?: string }>(), { lead: '' })
</script>

<template>
  <div class="section-step">
    <slot name="header" />
    <p v-if="lead || $slots.lead" class="section-step__lead">
      <slot name="lead">{{ lead }}</slot>
    </p>
    <div class="section-step__body">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .section-step {
    margin-bottom: var(--bf-sp-4);

    /* The font family is declared, not inherited: the app's legacy `body` rule is
       still 'Work Sans' (base.scss), so a DS block that leans on inheritance for
       its body font renders in the wrong typeface here. */
    &__lead {
      margin: 0 0 var(--bf-sp-2) var(--bf-section-header-content-offset);
      font-family: var(--bf-font-body);
      font-size: var(--bf-fs-sm);
      line-height: var(--bf-lh-normal);
      color: var(--bf-fg-2);
    }

    /* A flex column with a gap, not a bare margin: a step usually holds two or
       three blocks, and the gap belongs to the step rather than to an adjacency
       rule between whatever happens to be inside it. */
    &__body {
      margin-left: var(--bf-section-header-content-offset);
      display: flex;
      flex-direction: column;
      gap: var(--bf-sp-3);
    }
  }

  @media (max-width: 600px) {
    /* --bf-bp-sm — the marker column stops earning its width on a phone */
    .section-step__lead,
    .section-step__body {
      margin-left: 0;
    }
  }
</style>
